import axios from 'axios';

export interface SaveOrderPackageDimensionsInput {
  readonly orderNumber: string;
  readonly length: number;
  readonly width: number;
  readonly height: number;
  readonly skus: readonly string[];
}

export type PackageDimensionLookup =
  | { readonly found: false }
  | { readonly found: true; readonly length: number; readonly width: number; readonly height: number };

function readLookup(data: unknown): PackageDimensionLookup {
  if (data == null || typeof data !== 'object') return { found: false };
  if (!('found' in data) || data.found !== true) return { found: false };
  if (!('length' in data) || typeof data.length !== 'number') return { found: false };
  if (!('width' in data) || typeof data.width !== 'number') return { found: false };
  if (!('height' in data) || typeof data.height !== 'number') return { found: false };
  return { found: true, length: data.length, width: data.width, height: data.height };
}

export async function lookupOrderPackageDimensions(skus: readonly string[]): Promise<PackageDimensionLookup> {
  const response = await axios.post<unknown>('/api/orders/package-dimensions/lookup', { skus: [...skus] });
  return readLookup(response.data);
}

export async function pushOrderPackageDimensionsToShipStation(
  orderId: string | number,
  dimensions: Pick<SaveOrderPackageDimensionsInput, 'length' | 'width' | 'height'>,
): Promise<void> {
  await axios.post(`/api/orders/${orderId}/package-dimensions/shipstation`, {
    length: dimensions.length,
    width: dimensions.width,
    height: dimensions.height,
  });
}

export async function saveOrderPackageDimensions(
  orderId: string | number,
  input: SaveOrderPackageDimensionsInput,
): Promise<void> {
  await axios.post(`/api/orders/${orderId}/package-dimensions`, {
    ...input,
    skus: [...input.skus],
  });
}
